import React from "react";
import { useDispatch } from "react-redux";

import { Button } from "components";
import { NotesTable, NoteServiceContext } from "components/tables/notes";
import { applicationDealNotesService } from "services";
import { uiActions } from "store";
import { DealNotesGeneralCategoriesTypes } from "types";

import styles from "./dealNotes.module.scss";

const DealNotes = ({ applicationId, refetchBankNotes }) => {
	const dispatch = useDispatch();

	const handleAddNote = ({ addNote }) => {
		dispatch(
			uiActions.showModal("NOTE_FORM", {
				title: "Add Deal Note",
				dealNotesCategories:
					DealNotesGeneralCategoriesTypes.getOptions(),
				addNote(note) {
					return addNote({ entityId: applicationId, note });
				},
			}),
		);
	};

	const handleAddPrivateNote = ({ addNote }) => {
		dispatch(
			uiActions.showModal("NOTE_FORM", {
				title: "Add Private UW Note",
				isHideViewPrivatesNotes: true,
				addNote(note) {
					return addNote({
						entityId: applicationId,
						note: {
							...note,
							privateRiskUwOnly: true,
							phase: "Underwriting",
						},
					});
				},
			}),
		);
	};

	const handleViewNote = ({ note }) => {
		dispatch(
			uiActions.showModal("NOTE_LIST", {
				title: "View Deal Note",
				notes: [note],
			}),
		);
	};

	const handleEditNote = ({ note, editNote }) => {
		const isPrivateRiskUwOnly = note?.privateRiskUwOnly;
		dispatch(
			uiActions.showModal("NOTE_FORM", {
				title: note?.privateRiskUwOnly
					? "Edit Private UW Note"
					: "Edit Deal Note",
				isHideViewPrivatesNotes: isPrivateRiskUwOnly,
				note,
				showDiff: true,
				dealNotesCategories:
					!isPrivateRiskUwOnly &&
					DealNotesGeneralCategoriesTypes.getOptions(),
				editNote(updatedNote) {
					if (isPrivateRiskUwOnly) {
						return editNote({
							entityId: applicationId,
							note: {
								...updatedNote,
								privateRiskUwOnly: true,
							},
						});
					} else {
						return editNote({
							entityId: applicationId,
							note: updatedNote,
						});
					}
				},
			}),
		);
	};

	const handleDeleteNote = ({ note, deleteNote }) => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				title: "Are you sure you want to delete the note?",
				onConfirm() {
					return deleteNote({ entityId: applicationId, note });
				},
			}),
		);
	};

	return (
		<div className={styles.wrappNotes}>
			<NoteServiceContext.Provider
				value={{
					key: "underwritingDealNotes",
					service: applicationDealNotesService,
				}}
			>
				<NotesTable
					entityId={applicationId}
					onViewNote={handleViewNote}
					readOnly={false}
					onEditNote={handleEditNote}
					onDeleteNote={handleDeleteNote}
					AddNoteButton={({ addNote }) => (
						<Button
							onClick={() => handleAddNote({ addNote })}
							value="Add Note"
						/>
					)}
					AddPrivateNoteButton={({ addNote }) => (
						<Button
							onClick={() => handleAddPrivateNote({ addNote })}
							value="Add Underwriting Note"
							className="ml-4"
						/>
					)}
					dealNotesCategories={DealNotesGeneralCategoriesTypes}
					onSuccessDeleteNote={refetchBankNotes}
					onSuccessEditNote={refetchBankNotes}
					onSuccessAddNote={refetchBankNotes}
				/>
			</NoteServiceContext.Provider>
		</div>
	);
};

export default DealNotes;
